import styles from './styles.module.scss'

export default function Footer() {
  return (
    <div className={styles.footer}>
      <div className={styles.hr} />
      <h5>Looking to join an existing team?</h5>
      <div className={styles.information}>Ask your admin to invite you.</div>
    </div>
  )
}
